import React from 'react'
import {useTranslation} from "react-i18next"
import {useSelector} from "react-redux"
import Schokwave_EN from "./Schokwave_EN"
import Schokwave_RU from "./Schokwave_RU"
import Schokwave_BG from "./Schokwave_BG"

const Schokwave = () => {
    const {t} = useTranslation()
    const language = useSelector(state => state.language)

    switch (language) {
        case 'EN':
            return (
                <Schokwave_EN/>
            )
        case 'RU':
            return (
                <Schokwave_RU/>
            )
        case 'BG':
            return (
                <Schokwave_BG/>
            )
        default:
            return (
                <Schokwave_EN/>
            )
    }
}

export default Schokwave



// WEBPACK FOOTER //
// ./src/Components/Schokwave/Schokwave.js